import { Circles } from "react-loader-spinner";
import BlueButton from "../../../buttons/BlueButton";
import Send from "../../../icons/Send";
import Loader from "../../Loader";

export default function SubmitButton(
    {
        children,
        loading = false
    }
) {
    return (
        <button type="submit" className="w-full">
            <BlueButton icon={loading ? <div className="translate-x-3">
                <Circles color="white" width={24} height={24}/>
            </div> : <Send/>}>
                {children}
            </BlueButton>
        </button>
    )
}